import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, Building2, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  importedSiteImages,
  ministryCards,
  publicCtas,
  visionStatement,
} from '@/content/public-site-content';

export default function MinistryAboutPage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
      <section className="overflow-hidden rounded-[2rem] border border-border/70 bg-card shadow-sm">
        <div className="relative min-h-[320px]">
          <img
            src={importedSiteImages.ministryHero}
            alt="Dominion Mandate ministries"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background via-background/92 to-background/55" />
          <div className="relative z-10 max-w-3xl space-y-5 p-8 sm:p-10">
            <Badge variant="outline" className="w-fit border-primary/30 bg-primary/5">
              <Home className="mr-1 h-3 w-3 text-primary" />
              Ministries
            </Badge>
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Ministries</h1>
            <p className="text-base leading-7 text-muted-foreground sm:text-lg">
              {visionStatement}
            </p>
          </div>
        </div>
      </section>

      <section className="space-y-5">
        <div className="flex items-center gap-3">
          <Building2 className="h-5 w-5 text-primary" />
          <h2 className="text-2xl font-semibold">Our ministries</h2>
        </div>
        <p className="max-w-3xl text-muted-foreground">
          Ministries designed to meet the specific needs and desires of our members and the body of Christ at large, while fulfilling the mission to raise leaders that transform society.
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {ministryCards.map((ministry) => (
            <Card key={ministry.badge} className="overflow-hidden border-border/70 bg-card/95 py-0 shadow-sm">
              <div className="h-56 overflow-hidden bg-muted">
                <img src={ministry.image} alt={ministry.title} className="h-full w-full object-cover" />
              </div>
              <CardContent className="space-y-3 p-6">
                <Badge variant="outline" className="w-fit">{ministry.badge}</Badge>
                <h3 className="text-xl font-semibold">{ministry.title}</h3>
                <p className="text-sm leading-6 text-muted-foreground">{ministry.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      <section className="rounded-2xl border border-border/70 bg-card/90 p-8 text-center">
        <h2 className="text-xl font-bold">Quick actions</h2>
        <p className="mx-auto mt-2 max-w-2xl text-muted-foreground">
          Choose the next step that matches what you want to explore.
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-3">
          {publicCtas.map((cta) => (
            <Button key={cta.href} variant={cta.href === '/media' ? 'default' : 'outline'} asChild>
              <Link to={cta.href}>
                {cta.label}
                {cta.href === '/media' && <ArrowRight className="ml-2 h-4 w-4" />}
              </Link>
            </Button>
          ))}
        </div>
      </section>
    </div>
  );
}
